import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
const links = [{
  label: 'Note legali',
  href: '#mentions-legales'
}, {
  label: 'Termini e condizioni di vendita',
  href: '#cgv'
}, {
  label: 'Informativa sulla privacy',
  href: '#confidentialite'
}, {
  label: 'Contatti',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-pink-950 py-14 text-white md:py-16" data-id="element-70" data-mp="36pz9966ny5g3">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-71" data-mp="3ues8bbil0tex">
        <p className="inline-flex items-center gap-2.5 text-sm font-extrabold uppercase tracking-widest text-amber-300 md:text-base" data-id="element-72" data-mp="38h2z36jh6hs">
          <span className="h-3 w-3 rounded-full bg-pink-400 ring-4 ring-pink-400/20" aria-hidden="true" data-id="element-73" data-mp="3ldkdj3f9yapl" />
          Kit Attività Ottobre Rosa
        </p>

        <p className="mt-6 text-sm text-pink-200" data-id="element-74" data-mp="29yxaz74xfaj6">© 2026 — Tutti i diritti riservati</p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-pink-900 px-4 py-2.5 text-sm font-semibold text-pink-100 ring-1 ring-pink-800" data-id="element-75" data-mp="2eyt9iquuu9rc">
          <HeartHandshakeIcon className="h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" data-id="element-76" data-mp="3lbmtfq7jj4eu" />
          Hai bisogno di supporto? Per questioni relative alla salute, rivolgiti a un
          professionista sanitario qualificato.
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-pink-100" data-id="element-77" data-mp="3q83rpd8gez5n">
          {links.map(link => <li key={link.label} data-id="element-78" data-mp="817cg38o1ksh">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-amber-300" data-id="element-79" data-mp="33xgs5uoocw7">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-pink-800 pt-6 text-xs leading-relaxed text-pink-200" data-id="element-80" data-mp="cv1s8vl5hfma">
          Questo prodotto è destinato esclusivamente ad attività informative, di sensibilizzazione
          e facilitazione. Non sostituisce un parere medico o psicologico, né il supporto di un
          professionista sanitario.
        </p>
      </div>
    </footer>;
}